import { Input as AntInput } from "antd";
import { useRef, useEffect, useState } from "react";

function OtpInput({
  id,
  value: propValue,
  onChange,
  onBlur,
  onFocus,
  status,
  placeholder,
  length = 6,
  label,
  labelClass = "",
  mask,
  wrapperClass,
  setValue = () => {},
}) {
  const otpRef = useRef();
  const [value, setLocalValue] = useState(propValue || "");

  // Sync parent value
  useEffect(() => {
    setLocalValue(propValue || "");
  }, [propValue]);

  // Blur once OTP complete
  useEffect(() => {
    if (value?.length >= length) {
      otpRef.current?.blur();
    }
  }, [value, length]);

  useEffect(() => {
    if (otpRef.current) {
      otpRef.current.focus();
    }
  }, []);

  // ✅ WebOTP auto-fetch
  useEffect(() => {
    if ("OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          if (otp?.code) {
            setLocalValue(otp.code);
            onChange?.(otp.code);
            setValue(otp.code);
          }
        })
        .catch(() => {});
      return () => ac.abort();
    }
  }, [onChange, setValue]);

  return (
    <div className={`flex flex-col w-full gap-1 ${wrapperClass || ""}`}>
      {label && (
        <label htmlFor={id} className={`input-label ${labelClass}`}>
          {label}
        </label>
      )}
      <AntInput.OTP
        id={id}
        ref={otpRef}
        value={value}
        onChange={(val) => {
          setLocalValue(val);
          onChange?.(val);
          setValue(val);
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        status={status}
        mask={mask}
        length={length}
        placeholder={placeholder}
        type="tel"
        inputMode="numeric"
        autoComplete="one-time-code"
      />
    </div>
  );
}

export default OtpInput;
